export default __webpack_public_path__ + "static/media/Mystic's Sash of Yag.6e2fe77c.jpg";